module.exports = {"511421001":"文林街道","511421002":"普宁街道","511421003":"怀仁街道","511421004":"视高街道","511421102":"文宫镇","511421112":"禾加镇","511421116":"龙马镇","511421117":"方家镇","511421124":"大化镇","511421125":"高家镇","511421127":"禄加镇","511421128":"宝飞镇","511421129":"彰加镇","511421130":"慈航镇","511421131":"汪洋镇","511421132":"钟祥镇","511421133":"始建镇","511421134":"满井镇","511421135":"富加镇","511421136":"龙正镇","511421137":"黑龙滩镇","511421140":"北斗镇","511421143":"宝马镇","511421144":"珠嘉镇","511421146":"曹家镇","511421160":"谢安镇","511421161":"新店镇","511421162":"藕塘镇","511421163":"板桥镇","511421164":"贵平镇","511421200":"虞丞乡","511421203":"青岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511421.json
// module id = 2482
// module chunks = 0